import { render, staticRenderFns } from "./SettingsReport.vue?vue&type=template&id=397e93f7"
import script from "./SettingsReport.ts?vue&type=script&lang=ts&external"
export * from "./SettingsReport.ts?vue&type=script&lang=ts&external"
import style0 from "./SettingsReport.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports